import { createContext, useContext, useEffect, useState } from 'react';
import { UI } from './ui';

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('rev-lang') || 'en');
  useEffect(() => {
    localStorage.setItem('rev-lang', lang);
    document.documentElement.lang = lang === 'fr' ? 'fr-CA' : 'en-CA';
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, isFr: lang === 'fr' }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export function useT() {
  const { lang } = useLang();
  return UI[lang];
}
